<template>
  <div id="assign_employee_modal" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Assign Employees to {{ managerName }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ref="closeBtn">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="input-block mb-3">
            <label class="col-form-label">Select Employees</label>
            <v-autocomplete
              v-model="selectedEmployeeIds"
              :items="employeeOptions"
              item-title="text"
              item-value="id"
              multiple
              chips
              clearable
              variant="outlined"
              density="comfortable"
              placeholder="Search & Select employees"
              :loading="loading"
            ></v-autocomplete>
          </div>

          <div class="submit-section">
            <button class="btn btn-primary submit-btn" @click="saveAssignment" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { VUE_APP_API_BASE_URL } from "../../config";

export default {
  name: 'AssignEmployeeModal',
  data() {
    return {
      manager: null,
      allUsers: [],
      managersData: [],
      selectedEmployeeIds: [],
      loading: false,
    };
  },
  computed: {
    managerName() {
      return this.manager ? `${this.manager.first_name} ${this.manager.last_name}` : '';
    },
    employeeOptions() {
      return this.allUsers.map(user => ({
        id: user.id,
        text: `${user.first_name} ${user.last_name}`
      }));
    }
  },
  methods: {
    async updateValues(manager) {
      this.manager = manager;
      this.selectedEmployeeIds = [];
      await this.fetchData();
      
      // Find this manager in managersData to get currently assigned employees
      const managerId = manager.id || manager.user_id;
      const managerEntry = this.managersData.find(m => m.id === managerId);
      if (managerEntry && managerEntry.employees) {
        this.selectedEmployeeIds = managerEntry.employees.map(e => e.id);
      }
    },
    async fetchData() {
      this.loading = true;
      try {
        const [usersRes, managersRes] = await Promise.all([
          axios.get(`${VUE_APP_API_BASE_URL}/user/user-list`),
          axios.get(`${VUE_APP_API_BASE_URL}/admin/manager-employee-list`)
        ]);

        if (usersRes.data.status) {
          this.allUsers = usersRes.data.data;
        }
        if (managersRes.data.status) {
          this.managersData = managersRes.data.data;
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.loading = false;
      }
    },
    async saveAssignment() {
      this.loading = true;
      try {
        const response = await axios.post(`${VUE_APP_API_BASE_URL}/admin/assign-employees-to-manager`, {
          manager_id: this.manager.id || this.manager.user_id,
          employee_ids: this.selectedEmployeeIds
        });

        if (response.data.status) {
          this.$toast.success(response.data.message);
          this.$emit('updated');
          this.$refs.closeBtn.click();
        } else {
          this.$toast.error(response.data.message || "Failed to save assignment");
        }
      } catch (error) {
        this.$toast.error(error.response?.data?.message || "An error occurred");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
</style>
